








































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapGetters } from 'vuex'
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin'
import SlideList from '@/components/modules/App/SlideList.vue'
import FlatCard from '@/components/modules/App/Profile/FlatCard.vue'
import NoFlatPlug from '@/components/modules/App/Profile/NoFlatPlug.vue'
import { CatalogItem } from '@/requests/mainApi'
import { storeModuleName } from '@/views/App/Profile/store'
import { IFlatItem, IBookingItem } from '@/views/App/Profile/store/interfaces'

interface Data {
  viewCurrentFlats: CatalogItem[]
}

interface Methods {
  onSelectChunk: (value: CatalogItem[]) => void,
}

interface Computed {
  processedFavouriteFlats: IFlatItem[]
  bookingFlats: IBookingItem[]
  favouriteFlats: CatalogItem[]
}

interface Props {}

export default Vue.extend({
  name: 'FavouriteTab',
  components: {
    SlideList,
    FlatCard,
    NoFlatPlug
  },
  mixins: [iconsMixin],
  data () {
    return {
      viewCurrentFlats: [],
      countInChunk: 4
    }
  },
  computed: {
    processedFavouriteFlats () {
      let relevantBookingFlat
      return this.favouriteFlats.map(favouriteFlat => {
        relevantBookingFlat = this.bookingFlats
          .find(bookingFlat => favouriteFlat.id === bookingFlat.estate)
        return {
          ...favouriteFlat,
          isBooked: Boolean(relevantBookingFlat),
          bookingStatus: relevantBookingFlat ? relevantBookingFlat.bookingStatus : '',
          isFavourite: true
        }
      })
    },
    ...mapGetters(storeModuleName, ['bookingFlats']),
    ...mapGetters(['favouriteFlats'])
  },
  methods: {
    onSelectChunk (value: CatalogItem[]) {
      this.viewCurrentFlats = value
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
